import React, { useEffect, useState } from "react";
import Flickity from "react-flickity-component";
import "./style.css";
import { addDays, format } from "date-fns";
import useDesktopSize from "../../utils/hooks/useDesktopSize";
import { useTranslation } from "react-i18next";
import useLocaleByLanguage from "../../utils/hooks/useLocaleByLanguage";

interface IProps {
  onChangeDate?: (value: Date) => void;
}

const flickityOptions = {
  initialIndex: 0,
  wrapAround: false,
  freeScroll: true,
  pageDots: false,
  autoPlay: false,
  pauseAutoPlayOnHover: true,
  adaptiveHeight: true,
  setGallerySize: false,
  resize: true,
  cellAlign: "left",
  percentPosition: false,
  draggable: false,
  groupCells: 1,
};

const dateLength = 14;

const Calendar: React.FC<IProps> = ({ onChangeDate = () => {} }: IProps) => {
  const isDesktop = useDesktopSize();
  const [selectDateIndex, setSelectDateIndex] = useState(0);
  const [dates, setDates] = useState<Date[]>([]);
  const locale = useLocaleByLanguage();
  const { t } = useTranslation();

  const handleSelectDate = (date: Date, index: number) => {
    onChangeDate && onChangeDate(date);
    setSelectDateIndex(index);
  };

  useEffect(() => {
    const generatorDate = () => {
      let arr = [];
      for (let i = 0; i < dateLength; i++) {
        arr.push(addDays(new Date(), i));
      }
      setDates(arr);
    };
    generatorDate();
  }, []);

  return (
    <Flickity options={flickityOptions} className={isDesktop ? "calendar-wrapper" : "calendar-wrapper-mobile"}>
      {dates.map((item, index) => (
        <div
          key={index}
          className={`day-wrapper ${selectDateIndex === index ? "active-day-wrapper" : ""}`}
          onClick={() => handleSelectDate(item, index)}
        >
          <p>{format(item, "EE", { locale: locale })}</p>
          <p>{format(item, "dd.MM")}</p>
          {index === 0 && <p>{t("dzisiaj")}</p>}
          {index === 1 && <p>{t("jutro")}</p>}
        </div>
      ))}
    </Flickity>
  );
};

export default Calendar;
